'use server';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import type { AudioStory } from '@/contexts/audio-stories/types';

export async function listAudioStories(params?: {
  familyId?: string;
  limit?: number;
  offset?: number;
  onlyFavorites?: boolean;
}): Promise<ActionResult<{ audioStories: AudioStory[]; total: number }>> {
  const familyId = params?.familyId ?? (await SessionService.getFamilyId());
  if (!familyId) return { success: false, error: 'Not authenticated' };

  const { getAudioStoryRepository } = await import(
    '@/contexts/audio-stories/repositories'
  );
  const result = await getAudioStoryRepository().listByFamily({
    familyId,
    limit: params?.limit,
    offset: params?.offset,
    onlyFavorites: params?.onlyFavorites,
  });
  return { success: true, data: result };
}
